import React from "react";

function MohamedNabeelSaeed() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
            <h2 style={{color:"#3A3A3A"}}><b>Mohamed Nabeel Saeed</b></h2>
            <div style={{color:"#5E5550"}}>
            <h6><strong>SUMMARY</strong></h6>
            <p>
            Mohamed holds a  Bachelor of Laws (LLB (Hons)) degree from the University of Northampton in the UK (2008), where he was granted a scholarship by the University. Mohamed has been working with the Firm since 2009 whereby he concluded his mandatory two years of legal training and was admitted as a lawyer in the Kingdom of Bahrain.  Mohamed also holds a Master of Laws (LLM) in Islamic Finance and Business Law from BPP University.  Mohamed was awarded his LLM with Distinction in 2015.  His focus during his LLM was on Islamic Finance Law, Islamic Business Law, International Banking Law and Regulation and Compliance.  Mohamed handles daily tasks such as drafting legal advice on various day to day legal issues, communicating with clients on various cases handled by the Firm through all forums whether in person, phone or email,  making Court appearances where required to do so and drafting various legal documentation and contracts depending on client requirements.  Mohamed further  has a particular interest in litigation such as commercial litigation, property disputes and employment law disputes amongst other areas.    
            </p>
            <p>
            Mohamed is fluent in both Arabic and English. 
            </p>
            <h6><strong>CONTACT DETAILS</strong></h6>
            <p>
            Email:		m.saeed@nabeelsaeed.com
            </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default MohamedNabeelSaeed;
